import type { IconData } from '@stacksjs/iconify-core'

export const home1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.568 2.812a8.25 8.25 0 0 1 6.864 0c7.766 3.556 13.551 8.642 16.337 11.386c1.502 1.479 2.305 3.451 2.418 5.486c.138 2.507.313 6.573.313 11.159c0 3.236-.087 6.212-.187 8.564a7.145 7.145 0 0 1-6.927 6.854c-3.478.12-8.647.239-15.386.239s-11.908-.12-15.386-.239a7.145 7.145 0 0 1-6.927-6.854a204 204 0 0 1-.187-8.564c0-4.586.175-8.652.313-11.159c.113-2.035.916-4.007 2.418-5.486c2.786-2.744 8.572-7.83 16.337-11.386M16 36a2 2 0 1 0 0 4h16a2 2 0 1 0 0-4z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default home1Solid
